import { render, staticRenderFns } from "./voiceMessage.vue?vue&type=template&id=abc0ecee&scoped=true"
import script from "./voiceMessage.vue?vue&type=script&lang=js"
export * from "./voiceMessage.vue?vue&type=script&lang=js"
import style0 from "./voiceMessage.vue?vue&type=style&index=0&id=abc0ecee&prod&lang=stylus&rel=stylesheet%2Fstylus"
import style1 from "./voiceMessage.vue?vue&type=style&index=1&id=abc0ecee&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc0ecee",
  null
  
)

export default component.exports